import { Component, OnInit } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FolderService } from '../../services/folder.service';
import { Folder } from '../../models/folder';
import { ConfigService } from '../../services/config.service';
import { VendorComponent } from './vendor/vendor.component';
import { VendorService } from "../../services/vendor.service";
import { Methods } from "../../shared/methods";
import { User } from '../../models/user';
import swal from 'sweetalert2';
import { TitleService } from '../../services/title.service';
import { Cell, DinamicData } from "src/app/models/dinamic-data";
import { Router} from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { lastValueFrom } from 'rxjs';

declare var $: any;

@Component({
  selector: "app-vendors",
  templateUrl: "./vendors.component.html",
  styleUrls: ["./vendors.component.css"],
  providers: [FolderService]
})
export class VendorsComponent implements OnInit {
  public mtds: Methods = new Methods();
  public data: Array<any> = [];
  public options: Array<any> = [];
  public loading = false;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public activos = 1;
  public optionsButtonSelect;
  public optionSelectMenuTrigger;
  public config: Array<any> = [];
  public vendorData: DinamicData = new DinamicData(
    ['check','Rep Name', 'Company Name', 'Name', 'City', 'Date','Actions']
  )
  public bulk: Array<number> = [];
  public token;
  public reps;
  constructor(
    private titleService: Title,
    public dialog: MatDialog,
    private _folderService: FolderService,
    private _service: VendorService,
    private _config: ConfigService,
    private titleServices: TitleService,
    private _router: Router,
    private _userService: UserService
  ) {
    this.token = this._userService.getToken();
      this.titleService.setTitle('Vendors');
  }
  menuTriggerToShow(newValue: string) {
    if (newValue === "Active") { this.activos = 0; } else { this.activos = 1 }
    this.cambiarActivos()
    this.bulk = [];
  }
  ngOnInit() {
    this.GetRep();
    this.optionsButtonSelect= [
      { value: 'Active', label: 'Active'},
      { value: 'Inactive', label: 'Inactive'},
    ];
    this.optionSelectMenuTrigger='Active';
    this.loading = true;
/*     this._config.getConfig('vendors').subscribe(
      r => {
        if (r.data) {
          this.options = JSON.parse(r.data.data);
        } else {
          this.options = this.mtds.colopt(
            ['Rep Name', 'Company Name', 'Name', 'City', 'Date','Status', 'Actions'], [false]
          );
        }
        this.getVendors();
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    ); */ 
    this._config.getConfig('vendors').subscribe(
      r => {
        if (r.data) {
          this.options = JSON.parse(r.data.data);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          this.options = this.mtds.colopt(this.vendorData.headers, []);
        }
        this.loadDataAsync();
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );
    this.titleServices.setTitle('Vendors');
  }

  newVendor() {
    let user = new User(1, 'VENDOR', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, '', 1, 1, 1, '', 0, '', '', '', 0, 0, 0, 0, 0, 0, 0, '', '', '', '');
    let dialogRef = this.dialog.open(VendorComponent, {
      width: '80%',
      data: { user: user, sexos: [
        { value: '1', viewValue: 'Hombre' },
        { value: '0', viewValue: 'Mujer' }
      ] }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        this._service.newVendor(result).subscribe(
          (response: any) => {
            console.log(response);

            if (response.code === 200) {
              let userid = {
                "name": "mad",
                "value": response.user.id
              }

              if (response.hasfolder == null) {
                let folderNEw = new Folder(1, response.user.companyLinked.name, '', '', userid, '', 0, 0, 1, 0);
                console.log(folderNEw);
                this._folderService.create(JSON.parse(localStorage.getItem("token")), folderNEw).subscribe(
                  response => {
                    console.log(response);
                  },
                  error => {
                    console.log(<any>error);
                  }
                );
              }

              swal.fire({
              
                title: 'Vendor successfully added!',
                text: '',
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
              this.loadDataAsync();
              this.bulk = [];
            } else {
              swal.fire({
              
                title: response.status,
                text: response.msg,
                buttonsStyling: false,
               customClass:{
    confirmButton: 'btn btn-success'
            },
              });
            }

          },
          error => {
            console.log(<any>error);
          }
        );
      }
    });
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig('vendors', this.options).subscribe(
      r => {
        console.log(r)
/*         if (r.data) {
          this.config = JSON.parse(r.data.data);
        } else {
          this.config = this.mtds.colopt(
            this.vendorData.headers, [false]
          );
        }
        this.getOnlyVendor(); */
      }
    );
  }
  /*  */
  DeleteMultiple(){ 
    swal.fire({
      title: '',
      text: "Do you want to make this Users " + (this.activos === 1 ? 'inactive' : 'active'),
      showCancelButton: true,
      buttonsStyling: false,
    
       customClass:{
    confirmButton: 'btn btn-warning',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(function (result) {
      if (result.value) {
      let json =  {
        ids: this.bulk,
        activo: this.activos
      }
      this._service.updateMultiple(this.token, json).subscribe(
        response =>{
          
          if(response.status == 'success'){
           this.loadDataAsync();
   /*         this.mtds.notifySuccess(
              this.activos === 1 ? 'Company status has been changed to inactive' : 'Company status has been changed to active'
            ); */
            this.showToast('success', 'Company status has been changed to ' + (this.activos === 1 ? 'Inactive' : 'Activate')+ ' correctly', 2000)  
          } else {
            this.showToast('error', response.msg, 4000)
          }
          this.bulk = [];
        },
        error => {
          console.log(<any>error);
          this.bulk = [];
        });
      }
    }.bind(this));
  }
  /*  */
  getClass() {
    if (this.showDtButtons) return 'tdbtn';
    return 'tdbtn2'
  }
  getClassConta() {
    if (this.showDtButtons) return 'with-buttons';
    return 'with-buttons2'
  }
  showDtButtons: boolean = false;
  onToggleButtons(show: boolean) {
    this.showDtButtons = show;
  }
    /*fix Doble Call Backend  */
    private latestRequestId = 0;
    async loadDataAsync(params?: any): Promise<void> { 
      const currentRequestId = this.latestRequestId;
      this.loading = true;
      try {
 
        const response = await lastValueFrom(
          this._service.getOnlyVendors(
            this.activos,
            this.paginaActual,
            this.itemsPorPagina,
            this.filtros,this.filterrigh,this.sortStates

          )
        );
        if (currentRequestId !== this.latestRequestId) {
          console.log('Respuesta antigua ignorada');
          return;
        }
        this.vendorData = this.transformResponseToDinamicData(response);
      } catch (error: any) {
        this.mtds.notifyError(error.statusText, error.status);
      } finally {
        if (currentRequestId === this.latestRequestId) {
          this.loading = false;
        }
      }
    }
    private transformResponseToDinamicData(response: any): DinamicData {
      const headers = [...this.vendorData.headers];
      let rows = [];
      let row = [];
      this.paginaActual = Number(response.page_actual);
      this.itemsPorPagina = String(response.items_per_page);
      this.totalItems = Number(response.total_items_count);
      this.totalPaginas = Number(response.total_pages);
      this.vendorData.rows = [];

      let actionButtons = [
        { icon: 'remove_red_eye', action: 'Detail', color: 'info' },
      //  { icon: 'delete_outline', action: 'Remove', color: 'danger' }
      ]

      for (let element of response.data) {
        let selected_value = false;

        if (this.bulk.includes(element.id.toString()))
         selected_value = true;
        const date = new Date(element.createdAt);
        const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        row = [
            new Cell(element.id, {
              type: "checkbox",
              selected: selected_value,
             
            }),
            new Cell(element.managedByString ? element.managedByString : this.getRepName(element.managedBy) ),
            new Cell(element.companyLinked?.name ?? ''),
            new Cell(`${element.name ?? ''} ${element.surname ?? ''}`.trim()), 
            new Cell(element.companyLinked?.city ?? ''),
            new Cell(formattedDate ?? ''),
            new Cell(
              actionButtons, {type: 'actions'}
            )
          ];
          rows.push(row);
      }
      return new DinamicData(headers, rows);
    }
    /*  */
  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    

   /*  this.getData(); */
   this.loadDataAsync();
  }

  cambiarActivos() {
    if (this.activos === 1) { this.activos = 0; } else { this.activos = 1 }
    this.loadDataAsync();
  }

/*   getVendors() {
    this.loading = true;
    this._service.getVendors('VENDORS', this.activos).subscribe(
      (r) => {
        console.log(r);
        this.data = r;
        setTimeout(() => {
          this.loading = false;
        }, 300);
      },
      (error) => {
        this.mtds.notifyError(
          "Error " + error.status + ": " + error.statusText,
          error.status
        );
        this.loading = false;
      }
    );
  } */
  public filtros = [
/*     {
      key: "id",
      title: "ID",
      value: "",
      type: "contains",
      key_type: "id_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    }, */
    null,
    {
      key: "rep_name",
      title: "Rep Name",
      value: "",
      type: "contains",
      key_type: "rep_name_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "company_name",
      title: "Company Name",
      value: "",
      type: "contains",
      key_type: "company_name_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "name",
      title: "name",
      value: "",
      type: "contains",
      key_type: "name_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "city",
      title: "City",
      value: "",
      type: "contains",
      key_type: "city_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "date",
      title: "Date",
      value: "",
      type: "contains",
      key_type: "date_type",
      type_options: [
        { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' } ,  { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
      ],
    },
    null
  ];

  getOnlyVendor(e = null){ 
    
    this.loading = true;
    this._service.getOnlyVendors(this.activos,e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,this.filtros,this.filterrigh,this.sortStates).subscribe(
      response => {
        if (response.status === 'success') {
          this.paginaActual = Number(response.page_actual);
          this.itemsPorPagina = String(response.items_per_page);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);
          this.vendorData.rows = [];

          let actionButtons = [
            { icon: 'remove_red_eye', action: 'Detail', color: 'info' },
          //  { icon: 'delete_outline', action: 'Remove', color: 'danger' }
          ]

          for (let element of response.data) {
            let selected_value = false;

            if (this.bulk.includes(element.id.toString()))
             selected_value = true;
            const date = new Date(element.createdAt);
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            this.vendorData.rows.push(
              [ 
                new Cell(element.id , {
                  type: "checkbox",
                  selected: selected_value,
                 
                }),
                new Cell(element.managedByString ? element.managedByString : this.getRepName(element.managedBy) ),
                new Cell(element.companyLinked?.name ?? ''),
                new Cell(`${element.name ?? ''} ${element.surname ?? ''}`.trim()), 
                new Cell(element.companyLinked?.city ?? ''),
                new Cell(formattedDate ?? ''),
                new Cell(
                  actionButtons, {type: 'actions'}
                )
              ]
            );
          }
        }
        this.loading = false;
      },
      (error) => {
        this.mtds.notifyError(
          "Error " + error.status + ": " + error.statusText,
          error.status
        );
        this.loading = false;
      }
    );
  }
  activeVendor(id) {
  
    swal.fire({
      title: '',
      text: 'Do you want to make this vendor ' + (this.activos === 1 ? 'inactive' : 'active'),
      icon: "info",
      showCancelButton: true,
      buttonsStyling: false,

      customClass:{
    confirmButton: 'gts-btn-primary',
    cancelButton: 'gts-btn-primary-outline',
            },
      confirmButtonColor: '#9c27b0',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(function (result) {
      if (result.value) {
        this._service.activeVendor(id).subscribe(
          r => {
            if (r != null) {
              this.showToast('success', 'Vendor status has been changed to ' + (this.activos === 1 ? 'deactivated' : 'activate')+ ' correctly', 2000)
              this.loadDataAsync();
   /*            this.mtds.notifySuccess(
                this.activos === 1 ? 'Vendor status has been changed to inactive' : 'Vendor status has been changed to active'
              ); */
            }
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }.bind(this));
  }
  action(e) {
    console.log(e)
    console.log("here")
    console.log(e)
    switch (e.action) {
      case 'Detail':
        this._router.navigate(["/pages/user", e.id]);
        break;
      /* case 'Active':
        this.activeVendor(e.id)
        break;
      case 'Inactive':
        this.activeVendor(e.id)
        break;      */  
      default:
        break;
    }
  }

  GetRep() {
    this._userService.getAllUsersLite(this.token, "exceptuser").subscribe(
      response => {
        if (response.status == 'success') {
          this.reps = response.data; 
        }
      });
  }
  getRepName(managedById: number): string {
    if (this.reps) {
      const rep = this.reps.find(r => r.id === managedById);
      return rep ? `${rep.name} ${rep.surname}` : ''; 
    }
    return ''; 
  }

  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }

}
